// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"style_checkboxWrapper__Ln5Ut","checkboxLabel":"style_checkboxLabel__bRXkR","checkbox":"style_checkbox__Q2wbW","checkmark":"style_checkmark__2tkD+"};